import deepmerge from 'deepmerge'

/**
 * 入会情報
 */
export const init = {
  // 入力制限時刻
  timeLimit: 0,

  // すべて許諾事項に同意したか
  agreed: false,

  // アカウント情報
  account: {
    email: '',
    password: ''
  },

  // ユーザ情報
  profile: {
    familyName: '',
    givenName: '',
    familyKana: '',
    givenKana: '',
    gender: 0,
    birthday: '',
    postal: '',
    address1: '',
    address2: '',
    phone: ''
  },

  // 免許証情報
  license: {
    number: '',
    acquire: '',
    expire: '',
    issue: '',
    types: '',
    note: '',
    country: '',
    countryName: ''
  },

  // 同意事項
  optins: {
    promotion: 1
  },

  // 登録結果
  result: null
}

export default deepmerge(init, {})
